import { InitialState } from "./type";

export const initialState: InitialState = {
  sliderList: [],
  sliderListNotToken: [],
  shopList: [],
  categoryIdValue: 0,
  branchesList: [],
};
